const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path fill-rule="evenodd" d="M21 7.325 9.901 18.424 3 11.523l2.525-2.525 4.376 4.376L18.475 4.8z" clip-rule="evenodd"/></svg>';
export {
  e as w
};
